import { testimonials } from "@/mocks/manga";

const principles = [
  {
    icon: "ri-search-eye-line",
    title: "只做精选",
    desc: "不靠堆量，每一部入选作品都经过题材、完成度与可读性的三重筛选。",
  },
  {
    icon: "ri-stack-line",
    title: "完整连载",
    desc: "热门同步更新，冷门补录归档，追更不迷路，结局不烂尾。",
  },
  {
    icon: "ri-shield-check-line",
    title: "分类清晰",
    desc: "暗黑、邪典、重口、脑洞、怪谈、废土逐项细分，按口味精准入坑。",
  },
  {
    icon: "ri-team-line",
    title: "同好共建",
    desc: "欢迎推荐冷门佳作，读者反馈直达编辑，一起把好作品推给更多同好。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-12">
          <div>
            <p className="text-xs tracking-widest text-primary-400 mb-2">关于我们 · 品牌理念</p>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug mb-5">
              为非常规故事
              <br />
              <span className="text-primary-400">留下一个栖身之处</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
              歪歪漫画诞生于一群冷门漫画爱好者的执念。主流的榜单装不下暗黑的心理、
              邪典的叛逆、重口的冲击与脑洞的反转，于是我们决定自己动手——
              把散落在各处的冷门猎奇作品一一捡回，做分类、做整理、做同步更新。
            </p>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6">
              我们的内容原则很简单：<b className="text-foreground-200">尊重题材、尊重读者</b>。
              不夸大、不猎奇营销，只如实呈现每一部作品真正的气质，让你凭喜好自由选择，
              一站看全不迷路。
            </p>
            <div className="grid grid-cols-2 gap-3">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="rounded-lg p-4 bg-background-100 border border-background-300/40"
                >
                  <span className="w-8 h-8 rounded-md bg-primary-600/10 flex items-center justify-center text-primary-400 mb-2">
                    <i className={`${p.icon} text-base`}></i>
                  </span>
                  <h3 className="text-sm font-bold text-foreground-950 mb-1">{p.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs tracking-widest text-accent-400 mb-4 text-center">读者口碑 · 真实评价</p>
            <div className="space-y-4">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="rounded-lg p-5 bg-background-100 border border-background-300/40"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={t.avatar}
                      alt={`${t.name} 读者头像`}
                      className="w-11 h-11 rounded-full object-cover object-top border border-background-300"
                    />
                    <div>
                      <figcaption className="text-sm font-bold text-foreground-950">{t.name}</figcaption>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                  <blockquote className="text-sm text-foreground-400 leading-relaxed">
                    “{t.text}”
                  </blockquote>
                  <div className="flex gap-0.5 mt-3 text-accent-400 text-xs">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}